import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import type { PreviewRotation } from '../models';

export type ImageRendererObjectFit =
    | 'contain'
    | 'cover'
    | 'fill'
    | 'none'
    | 'scale-down';

@Component({
    selector: 'qpx-image-renderer',
    templateUrl: './image-renderer.html',
    styleUrl: './image-renderer.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'preview-image-wrapper',
        '[class.hand-tool-active]': 'handTool()',
        '[class.is-panning]': 'panning()',
        '[class.framed]': 'framed()',
        '[style.height]': 'height()',
        '(pointerdown)': 'pointerDown.emit($event)',
        '(pointermove)': 'pointerMove.emit($event)',
        '(pointerup)': 'pointerEnd.emit($event)',
        '(pointercancel)': 'pointerEnd.emit($event)',
        '(pointerleave)': 'pointerEnd.emit($event)',
    },
})
export class ImageRenderer {
    //#region Inputs
    public readonly source = input.required<string>();
    public readonly alternativeText = input.required<string>();
    public readonly width = input.required<string>();
    public readonly height = input.required<string>();
    public readonly maxWidth = input.required<string>();
    public readonly maxHeight = input.required<string>();
    public readonly objectFit = input.required<ImageRendererObjectFit>();
    public readonly rotation = input.required<PreviewRotation>();
    public readonly aspectRatio = input('auto');
    public readonly handTool = input(false);
    public readonly panning = input(false);
    public readonly framed = input(false);
    //#endregion

    //#region Outputs
    public readonly viewerLoaded = output<void>();
    public readonly viewerLoadError = output<Event>();
    public readonly pointerDown = output<PointerEvent>();
    public readonly pointerMove = output<PointerEvent>();
    public readonly pointerEnd = output<PointerEvent>();
    //#endregion
}
